import { useEffect, useState } from "react";

import { useHistory } from "react-router";

import { Button, Link, Text } from "@alpacahq/ui/old";

import AmplitudeProvider from "~/AmplitudeProvider";
import { FullScreenSpinner } from "~/v2/components/common";
import { Path } from "~/v2/path";
import { UserActions } from "../../api/auth";
import { useGetTradingAccount } from "../../api/hooks/useGetAccount";
import { isPaperOrOnboarding } from "../../utils";
import { CONTACT_URL } from ".";

export const Verified = () => {
  const history = useHistory();

  const [loggedIn, setLoggedIn] = useState(false);

  const { account } = useGetTradingAccount();

  const onLoginClicked = () => history.push(Path.ROUTE_LOGIN);

  useEffect(() => {
    (async () => setLoggedIn(await UserActions.checkLoggedInStatus()))();
    AmplitudeProvider.dispatch("onboardingv2_signup_verification_completed");
  }, []);

  if (loggedIn && account?.status && !isPaperOrOnboarding(account)) {
    history.push(Path.ROUTE_DASHBOARD);
  }

  if (loggedIn && !account) {
    return <FullScreenSpinner />;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-7">
      <h1 className="text-center font-bold text-3xl text-gray-900">
        Email verified!
      </h1>

      <div className="flex flex-col items-center justify-center gap-4">
        <Text className="text-center text-gray-600">You can now log in</Text>
        <Button onClick={onLoginClicked} type="button">
          Take me to login
        </Button>
        <Text className="text-center text-gray-600">
          Need more help?{" "}
          <Link href={CONTACT_URL} rel="noopener">
            Contact support
          </Link>
        </Text>
      </div>
    </div>
  );
};
